var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showTitle)?_c('div',{staticClass:"nav-title"},[_c('h3',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }